export * from './AverageTraffic'
